import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-contract-edition-iban",
  standalone: true,
  imports: [CommonModule, FormsModule, DialogModule, DropdownModule, ButtonModule, TranslateModule],
  templateUrl: "./contract-edition-iban.component.html",
})
export class ContractEditionIbanComponent implements OnInit {
  @Input() isVisible!: boolean;
  @Input() hasMemberMultipleReferences!: boolean;
  @Output() isVisibleChange = new EventEmitter<{ validate: boolean; isOwner: boolean; isAll: boolean }>();
  optionsOwner: string[] = [];
  optionsAllContract: string[] = [];
  allContractSelection!: string;
  isOwner!: string;

  constructor(private readonly translate: TranslateService) {}
  ngOnInit(): void {
    this.optionsOwner = [
      this.translate.instant("paymentInfo.accountOwnerYes"),
      this.translate.instant("paymentInfo.accountOwnerNo"),
    ];
    this.isOwner = this.optionsOwner[0];
    this.optionsAllContract = [this.translate.instant("StandardPopup.Yes"), this.translate.instant("StandardPopup.No")];
    this.allContractSelection = this.optionsAllContract[0];
  }

  cancel() {
    this.isVisibleChange.emit({ validate: false, isOwner: false, isAll: false });
  }

  validate() {
    const isOwner = this.isOwner === this.translate.instant("paymentInfo.accountOwnerYes");
    const isAll = this.allContractSelection === this.translate.instant("StandardPopup.Yes");
    this.isVisibleChange.emit({ validate: true, isOwner, isAll });
  }
}
